var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 32.0833C25.5537 32.0833 32.0827 25.5544 32.0827 17.5C32.0827 9.44563 25.5537 2.91667 17.4993 2.91667C9.44497 2.91667 2.91602 9.44636 2.91602 17.5C2.91602 25.5536 9.44497 32.0833 17.4993 32.0833Z",
    stroke: "#721372",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 22.594C6.29417 23.363 7.67569 23.363 8.51958 22.594C9.78542 21.439 8.69313 17.936 10.4665 16.9699C12.2383 16.0038 14.9399 20.2862 17.4643 18.8774C19.9886 17.4679 17.2266 13.7098 18.978 12.1866C20.7295 10.6633 23.0081 12.3813 23.4062 9.83355C23.8044 7.28584 21.5483 8.39126 21.1152 5.98355C20.8274 4.37938 20.8274 3.53598 21.1152 3.45334M21.1604 31.6094C19.7944 30.2108 19.3027 28.911 19.6853 27.7098C20.2592 25.9073 21.2064 26.0138 21.6191 24.8996C22.0318 23.7854 20.8658 22.198 23.4529 20.8418C25.1781 19.9376 27.5501 20.9854 30.5689 23.9852",
    stroke: "#721372",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoll);
export default __webpack_public_path__ + "static/media/boll.3175d02cfe67e461604a6d48176a8ec7.svg";
export { ForwardRef as ReactComponent };